exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".file-upload-tool .bottom-bar {\n  border-top: 1px solid #EEEEEE;\n  padding: 10px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n.file-upload-tool .bottom-bar > * {\n  margin: 0 16px;\n}\n", ""]);
